import { render, staticRenderFns } from "./IconGateway.global.vue?vue&type=template&id=69bb4c7e&scoped=true&lang=pug&"
import script from "./IconGateway.global.vue?vue&type=script&lang=ts&"
export * from "./IconGateway.global.vue?vue&type=script&lang=ts&"
import style0 from "./IconGateway.global.vue?vue&type=style&index=0&id=69bb4c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bb4c7e",
  null
  
)

export default component.exports